// extracted by mini-css-extract-plugin
export default {"wrap":"ReadinessRing_wrap__n9VrN","ring":"ReadinessRing_ring__cYKNo","inner":"ReadinessRing_inner__KPVp5","value":"ReadinessRing_value__+xXoo","label":"ReadinessRing_label__d80C-"};